import { IRouteAll, RouteActionTypes, ADD_ROUTE, UPDATE_ROUTE, DELETE_ROUTE } from "./types";

export function addCurrentPath(data: IRouteAll): RouteActionTypes {
    return {
        type: ADD_ROUTE,
        data: data
    }
}

export function updateCurrentPath(data: IRouteAll): RouteActionTypes {
    return {
        type: UPDATE_ROUTE,
        data: data
    }
}

export function deleteCurrentPath(data?: IRouteAll): RouteActionTypes {
    return {
        type: DELETE_ROUTE,
        data: data!
    }
}